module.exports = " <div class=toast> <div class=\"paco icon\" v-bind:class=\"{'icon-right-o':type=='success',success:type=='success','icon-wrong-o':type=='fail',fail:type=='fail','icon-opps':type=='opps', opps:type=='opps'}\"></div> <p class=message>{{message}}</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast.vue
// module id = 139
// module chunks = 1